<template>
    <ul class="list-group hidden-xs cart-payment-content" v-show="show">
        <li><h4>{{ variant.name }}</h4></li>
        <li v-bind:class="{ 'active' : !values || values && values.length === 0 }"><a @click="setVariant(null)">Všetky<span class="label-in pull-right"><p>{{ products.length }}</p></span></a></li>
        <li v-for="(item, index) in sortedVariants" v-bind:class="{ 'active' : isActive(item[0]) }" v-if="index + 1 <= max">
            <a @click="setVariant(item[0])">
                <div class="checkbox-inline">
                    <input type="checkbox" :checked="isActive(item[0])" class="checked">
                    <label></label>

                    {{ item[1] }} <span class="label-in pull-right"><p>{{ productsWithVariant(item[0]) }}</p></span>
                </div>
            </a>
        </li>
        <li v-if="sortedVariants.length > max">
            <a class="show-all" @click.prevent="max = sortedVariants.length + 1"><i class="fa fa-chevron-down"></i> Zobraziť všetko</a>
        </li>
    </ul>
</template>

<script>
    export default {
        props : ['variant', 'variantid', 'default', 'variants', 'products'],

        data(){
            return {
                values : this.default,
                show : false,
                max : 3,
            }
        },

        watch: {
            variants : {
                deep : true,
                handler(item){
                    if ( this.variantid in item ){
                        this.values = item[this.variantid];
                    }
                },
            },
            products(){
                this.show = false;
            }
        },

        computed: {
            sortedVariants(){
                var items = [];

                for ( var key in this.variant.variants ){
                    items.push({
                        id : key,
                        item : this.variant.variants[key],
                    });
                }

                items = items.sort((a, b) => {
                    a = a.item;
                    b = b.item;

                    if ( this.variant.is_numeric ){
                        return this.toNumber(a.name) - this.toNumber(b.name);
                    }

                    return (a.name||'').toLowerCase().localeCompare((b.name||'').toLowerCase(), 'sk');
                });

                var data = [];
                for ( var i = 0; i < items.length; i++ ) {
                    data.push([items[i].id, items[i].item.name])
                }

                return data;
            },
        },

        methods: {
            toNumber(s){
                var regex = /[+-]?\d+(\.\d+)?/g;

                var number = s.replace(/\,/g, '.').match(regex).map(function(v) {
                    return parseFloat(v);
                });

                if ( number.length )
                    return parseFloat(number[0]);

                return 0;
            },
            setVariant(id){
                if ( id )
                    id = parseInt(id);

                var values = this.values||[];

                if ( id === null )
                    values = [];
                else if ( values.indexOf(id) === -1 )
                    values.push(id);
                else
                    values.splice(values.indexOf(id), 1);

                this.$set(this.$parent.variants, this.variantid, values);

                this.$parent.setHashQuery(this.variantid, values.join(','));

                $('html, body').animate({
                    scrollTop: $(".offer-content").offset().top
                }, 500);
            },
            isActive(id){
                var active = this.values && $.isArray(this.values) && this.values.map(item => {
                    return parseInt(item);
                }).indexOf(parseInt(id)) > -1;

                if ( active == true )
                    this.max = 999;

                return active;
            },
            productsWithVariant(id){
                var length = this.products.filter(function(product){
                    if ( (this.variantid in product.variants) )
                    {
                        if ( product.variants[this.variantid].variants && id in product.variants[this.variantid].variants )
                            return true;
                    }
                }.bind(this)).length;

                if ( length > 0 )
                    this.show = true;

                //If selected variant need's to be hidden
                else {
                    if ( this.variantid in this.variants && this.variants[this.variantid] == id )
                        this.variants[this.variantid] = null;
                }

                return length;
            },
        }
    }
</script>
